class SliderItem {
    constructor(id, title, image, url, date, author=null) {
        this.date = date;
        this.url = url;
        this.image = image;
        this.url =  url;
        this.title = title;
        this.author = author;
        this.id = id;
    }
}

export default SliderItem;